import {
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLInt,
  GraphQLString,
  GraphQLFloat
} from 'graphql';

import Node from './node.gql';
import SuccessStatusEnumType from './enums/successStatus.gql';
import CompletionStatusEnumType from './enums/completionStatus.gql';

const SectionCompletionStatusEnum = {
  complete: 'COMPLETE',
  inComplete: 'IN_COMPLETE',
  notAttempted: 'NOT_ATTEMPTED'
};

const SuccessStatusEnum = {
  pass: 'PASS',
  fail: 'FAIL',
  na: 'NA'
};

const sectionPerformanceType = new GraphQLObjectType({
  name: 'SectionPerformance',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID)
    },
    pid: {
      type: GraphQLString
    },
    timeSpent: {
      type: GraphQLInt
    },
    completionDate: {
      type: GraphQLString
    },
    progressMeasure: {
      type: GraphQLFloat
    },
    scaledProgressMeasure: {
      type: GraphQLFloat
    },
    successStatus: {
      type: SuccessStatusEnumType,
      resolve: root => SuccessStatusEnum[root.successStatus]
    },
    completionStatus: {
      type: CompletionStatusEnumType,
      resolve: root => SectionCompletionStatusEnum[root.completionStatus]
    }
  }),
  interfaces: [Node.nodeInterface]
});

window[sectionPerformanceType.name + 'GQLType'] = sectionPerformanceType;

export default sectionPerformanceType;
